import session from "../session";
import { feedApi } from "@/http";

export default class FeedApi {
  createMediaObject() {
    return feedApi({
      method: "POST",
      url: "/media/",
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  addTagToMediaObject(id, data) {
    return feedApi({
      method: "PUT",
      url: `/media/tag/${id}`,
      data: data,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  removeTagFromMediaObject(mediaId, tagId) {
    return feedApi({
      method: "DELETE",
      url: `/media/tag/${mediaId}/${tagId}`,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  createPost(data) {
    return feedApi({
      method: "POST",
      url: "/post/",
      data: data,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  deletePost(postId) {
    return feedApi({
      method: "DELETE",
      url: `/post/${postId}`,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  makePostWanted(id) {
    return feedApi({
      method: "PUT",
      url: `/post/engage/${id}`,
      data: {
        action_type: "LIKE",
      },
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  makePostUnWanted(id) {
    return feedApi({
      method: "DELETE",
      url: `/post/engage/${id}`,
      data: {
        action_type: "LIKE",
      },
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  followBrand(id) {
    return feedApi({
      method: "PUT",
      url: `/post/engage/${id}`,
      data: {
        action_type: "FOLLOW",
      },
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  unfollowBrand(id) {
    return feedApi({
      method: "DELETE",
      url: `/post/engage/${id}`,
      data: {
        action_type: "FOLLOW",
      },
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  viewedAPost(id) {
    return feedApi({
      method: "PUT",
      url: `/post/engage/${id}`,
      data: {
        action_type: "VIEW",
      },
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
}
